"use client";

import { SelectedPageModel } from "@/types/SelectedPageModel";
import Link from "next/link";
import { Page } from "@/payload-types";
import { useLocalityService } from '@/providers/Locality';

export default function ResultFooter({
  title,
  subItems,
}: {
  title: string;
  subItems: SelectedPageModel[];
}) {
  const localityService = useLocalityService();

  return (
    <>
      <h3 className="text-1xl mt-5 max-w-3xl font-bold tracking-tight text-gray-600 sm:text-2xl">
        {title}
      </h3>
      <div className="mt-2 grid grid-cols-1 gap-4 px-10 sm:grid-cols-2">
        {subItems.map((product) => (
          <div
            key={product.id}
            className="relative flex items-center space-x-3 rounded-lg border border-gray-300 bg-white px-6 py-2 shadow-sm focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400"
          >
            <div className="min-w-0 flex-1">
              <Link
                href={localityService.addBreadcrumbLocaliteToUrl(
                  (product.page as Page).breadcrumbs || [],
                )}
                className="focus:outline-none"
              >
                <span aria-hidden="true" className="absolute inset-0" />
                <h4 className="text-m font-medium text-gray-900">
                  {(product.page as Page).title}
                </h4>
                <p className="truncate text-sm text-gray-500">
                  {product.description}
                </p>
                {/* {product.pageRichText && (
                                    <RichText
                                        resource={product.pageRichText}
                                        
                                    />
                                )} */}
              </Link>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
